import { render, staticRenderFns } from "./SpellcheckerPanelContent.vue?vue&type=template&id=d6f112aa&scoped=true"
import script from "./SpellcheckerPanelContent.vue?vue&type=script&lang=js"
export * from "./SpellcheckerPanelContent.vue?vue&type=script&lang=js"
import style0 from "./SpellcheckerPanelContent.vue?vue&type=style&index=0&id=d6f112aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f112aa",
  null
  
)

export default component.exports